/** One automation on the Case Automations board: what it is, and Run. */
import { Play, Zap } from "lucide-react";
import type { FC } from "react";

import { Surface } from "@/components/surface";
import { Button } from "@/components/ui/button";
import { IconTile } from "@/components/ui/icon-tile";
import type { FirmSkillSummary } from "@/features/firmKnowledge/types";

type Props = {
  skill: FirmSkillSummary;
  onRun: (skill: FirmSkillSummary) => void;
};

export const AutomationCard: FC<Props> = ({ skill, onRun }) => (
  <Surface className="gap-2 p-3" data-testid={`automation-card-${skill.id}`}>
    <div className="flex items-center gap-2.5">
      <IconTile icon={Zap} />
      <span
        className="truncate text-base font-medium text-fg"
        title={skill.description || undefined}
      >
        {skill.title}
      </span>
    </div>
    {skill.description ? (
      <p className="line-clamp-2 text-sm text-fg-3">{skill.description}</p>
    ) : null}
    <div className="mt-auto flex items-center justify-end">
      <Button
        variant="secondary"
        size="sm"
        onClick={() => onRun(skill)}
        data-testid="automation-run"
      >
        <Play />
        Run
      </Button>
    </div>
  </Surface>
);
